<template>
  <div>
    <div class="search-list">
      <span class="search-label">服务类型：</span>
      <div class="search-con">
        <a :class="{'search-active' : selectedResult.type_id == 0}"
           @click="tabHospitalIndex(0,'不限',1,'type_id','服务类型')">不限</a>
        <a :class="{'search-active' : selectedResult.type_id == list.id}"
           v-for="(list,index) in countries"
           :key="list.id"
           @click="tabHospitalIndex(list.id,list.name,1,'type_id','服务类型')">{{list.name}}</a>
      </div>
    </div>
    <div class="search-list">
      <span class="search-label">疾病类型：</span>
      <div class="search-con">
        <a :class="{'search-active' : selectedResult.disease_id == 0}"
           @click="tabHospitalIndex(0,'不限',1,'disease_id','疾病类型')">不限</a>
        <a :class="{'search-active' : selectedResult.disease_id == list.id}"
           v-for="(list,index) in menus"
           :key="list.id"
           @click="tabHospitalIndex(list.id,list.name,1,'disease_id','疾病类型',index)">{{list.name}}</a>
      </div>
    </div>
    <div class="search-list"
         v-if="bigList.length && selectedResult.disease_id!=0">
      <span class="search-label">疾病：</span>
      <div class="search-con">
        <a :class="{'search-active' : selectedResult.id == list.id}"
           v-for="(list,index) in bigList"
           :key="list.id"
           @click="tabHospitalIndex(list.id,list.name,1,'id','疾病')">{{list.name}}</a>
      </div>
    </div>
    <!-- <div class="search-input">
      <label for="keyword">关键字：</label>
      <input type="text"
             v-model="keyword">
      <button class="search-btn"
              @click="searching">搜索</button>
    </div> -->
  </div>
</template>
<script>
import * as apis from "@/api/other"
import * as api from '@/api/success';
export default {
  data () {
    return {
      bigList: [],
      keyword: '',
      countries: [],
      service: [],
      diseases: [],
      departments: [],
      selectedResult: {
        disease_id: 0,
        type_id: 0,
        id: 0
      },
      params: {
        disease_id: 0,
        type_id: 0,
        id: 0
      },
      menus: []
    }
  },
  created () {
    this.selectedResult.type_id = this.$route.params.type_id
    this.params.type_id = this.$route.params.type_id
  },
  mounted () {
    this.getCountry();
    this.getSuccessLeftMenu()
  },
  methods: {
    sendParams () {
      this.$emit("showSideMenu", flag)
    },
    tabHospitalIndex (val, name, select, form_id, form_name, index) {
      if (form_name === '疾病类型' && val != 0) {
        this.bigList = this.menus[index].disease
        this.selectedResult.id = 0;
        this.params.id = 0;
      }
      if (form_name === '疾病类型' && val === 0) {
        this.selectedResult.id = 0;
        this.params.id = 0;
      }
      if (form_name === '服务类型') {
        this.$router.push({
          name: 'successCase',
          params: {
            type_id: val
          }
        })
      }
      this.selectedResult[form_id] = val;
      this.params[form_id] = val;
      this.$emit("searchResult", this.params);
    },
    searching () {
      this.params.keyword = this.keyword;
      this.$emit("searchResult", this.params);
    },
    async getCountry () {
      try {
        let data = {};
        let res = await apis.getServiceMenu(data);
        if (res.code == 200) {
          this.countries = res.data;
        }
      } catch (e) {
        window.console.log(e)
      }
    },
    getOtherTypes () {
      this.selectedResult[`disease${item.id}`] = [];
    },
    async getSuccessLeftMenu () {
      try {
        let res = await api.getSuccessMenu({});
        if (res.code == 200) {
          this.menus = res.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
  }
}
</script>
<style lang="less" scoped>
.search-input {
  margin-bottom: 15px;
  input {
    height: 24px;
  }
}
.search-selects {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .ivu-select {
    width: 280px;
  }
  .ivu-icon-ios-arrow-down:before {
    content: '\F33D';
  }
  .ivu-select-large.ivu-select-single .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-single {
    .ivu-select-selection {
      .ivu-select-selected-value {
        padding-left: 20px;
      }
    }
  }
}
.search-list {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  .search-label {
    display: inline-block;
    width: 80px;
    font-size: 14px;
    color: #333130;
    line-height: 24px;
  }

  .search-con {
    flex: 1;
    height: 52px;
    transition: all linear 0.5s;
    overflow: hidden;
    a {
      display: inline-block;
      height: 24px;
      color: #333130;
      font-size: 14px;
      line-height: 24px;
      border-radius: 4px;
      padding: 0 10px;
      margin-right: 10px;
      margin-bottom: 28px;
    }
    a.search-active {
      background: #ae1e10;
      color: #fff;
    }
  }
  .con1 {
    height: 52px;
    transition: height linear 0.5s;
  }
  .con2 {
    height: auto;
    transition: height linear 0.5s;
  }
}
.search-second {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  a.search-active {
    background: #ae1e10;
    color: #fff;
  }
  .search-sub-label {
    display: inline-block;
    min-width: 120px;
    height: 24px;
    color: #333130;
    font-size: 14px;
    padding: 0 10px;
    margin-right: 10px;
    box-sizing: border-box;
    border-right: 2px solid #8c8c8c;
  }
}
.search-slide {
  width: 80px;
  color: #ae1e10;
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
  padding: 0 10px;
}
.search-btn {
  width: 80px;
  background: #ae1e10;
  color: #fff;
  font-size: 14px;
  line-height: 24px;
  border: none;
}
</style>

